import React from 'react';
import { View, Text,StyleSheet} from '../Primitives'
import dayjs from 'dayjs';

const boxStyle = StyleSheet.create({
    
    box:{
        display:'flex',

        border: '1pt solid #000',
         marginLeft:30,
        marginRight:30,
        marginBottom:15,
        height:'auto',
        
    },
    charterRequestParent:{
        display:'flex',

        marginLeft:30,
        marginRight:30,
        marginBottom:15,
        height:'auto'

    },
    rowContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex:1,
        marginBottom:15,
    },
    textRowContainer: {
        display: 'flex',
        flexDirection: 'row',
        flex:1,
        alignContent:'center',
        alitnItems:'center',

    },
    flexBox:{
        display:'flex',
        flex:1,
        marginBottom:5
    },
   
    leftText:{
        fontSize:12,
        margin:15,
        fontFamily:'Helvetica-Bold'
    },
    rightText:{
        fontSize:15,
        margin:15,
        
    },
    jbNum:{
        fontSize:13,
    },
    statusText: {
        fontSize: 11,
    }

})

const BidHistoryDetail = ({charter}) => {

     return <View style={boxStyle.box}>
        <View style={boxStyle.rowContainer}>
            <View style={boxStyle.textRowContainer}>
                <Text style={boxStyle.leftText}>Reference Number:</Text>
                <Text style={boxStyle.rightText}>JB{charter.jobReference}</Text>
            </View>
            <View style={boxStyle.textRowContainer}>
                <Text style={boxStyle.leftText}>Purchase Order Number</Text>      
                <Text style={boxStyle.rightText}>{charter.purchaseOrderNumber}</Text>
            </View>
        </View>
    
        <View style={boxStyle.rowContainer}>
            <View style={boxStyle.textRowContainer}>
                <Text style={boxStyle.leftText}>Date:</Text>
                <Text style={boxStyle.rightText}>{dayjs().format("DD/MMM/YYYY")}</Text>
            </View>       
            <View style={boxStyle.textRowContainer}>
                <Text style={boxStyle.leftText}>Bids:</Text>
                <Text style={boxStyle.rightText}>{charter.bids.length}</Text>
            </View>
        </View>
    </View>
  
}
export default BidHistoryDetail;